import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { FeatureService } from './feature.service';

@Injectable()
export class FeatureGuardService implements CanActivate {
  constructor(private featureService: FeatureService) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    const featureFlag = route.data['feature'];
    if (featureFlag) {
      return this.featureService.isEnabled(featureFlag);
    }
    return true;
  }
}
